module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "articlePage",
    staticClass: "page-node",
    class: ("page-type-" + _vm.nodeType)
  }, [_c('svg', {
    staticClass: "sr-only",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('def', [_c('filter', {
    attrs: {
      "id": "blur-effect--20"
    }
  }, [_c('feGaussianBlur', {
    attrs: {
      "edgeMode": "duplicate",
      "stdDeviation": "20"
    }
  }), _c('feComponentTransfer', [_c('feFuncA', {
    attrs: {
      "tableValues": "1 1"
    }
  })], 1)], 1)])], 1), _c('CusCarousel', {
    ref: "cusCarousel",
    staticClass: "article-carousel",
    attrs: {
      "sliderOptions": _vm.sliderOptions,
      "selector": "slider-1",
      "extraSlots": _vm.carouselExtraSlots
    },
    on: {
      "slideProgress": _vm.slideProgress,
      "slideChangeEnd": _vm.slideChangeEnd,
      "slideChangeStart": _vm.slideChangeStart
    }
  }, [_c('widget-share-buttons', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.relatedPersonOverlay.toggle),
      expression: "!relatedPersonOverlay.toggle"
    }],
    ref: "shareButtons",
    class: ['articleView__shareButtons', 'hidden-sm-up', _vm.shareBarActive, _vm.shareBarNoAnimation ? 'no-animation' : '', {
      inCard: _vm.inCard
    }],
    attrs: {
      "slot": "sharebar",
      "mode": "sticky",
      "url": _vm.shareData.url,
      "shortenUrl": _vm.shareData.shortenUrl,
      "title": _vm.shareData.title,
      "thumbnail": _vm.shareData.thumbnail,
      "gtmType": "gtmType_shareBtn-adhesiveBar"
    },
    slot: "sharebar"
  }), _c('div', {
    staticClass: "slider-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._l((_vm.articleList), function(articleNID, key) {
    return _c('div', {
      key: key,
      ref: _vm.getWrapperRef(articleNID),
      refInFor: true,
      staticClass: "article-view-wrapper slider-panel scroll-x-hidden",
      class: {
        active: _vm.isActive(articleNID), touchtopbottom: _vm.reachTopBottom, preventScroll: _vm.preventScroll
      },
      attrs: {
        "data-nid": articleNID
      }
    }, [(_vm.showSeoTitle && _vm.node.title) ? _c('h1', {
      staticClass: "news-title"
    }, [_vm._v(_vm._s(_vm.node.title))]) : _vm._e(), (_vm.prevArticleNID && _vm.activeNID == articleNID && _vm.showPrevCardCover) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showTopCover),
        expression: "showTopCover"
      }],
      staticClass: "prevCardCover",
      class: {
        reset: _vm.cardReset, animate: _vm.cardAnimate
      },
      style: ({
        'margin-top': (_vm.prevCardMargintop + "px"),
        height: (_vm.viewportHeight + "px"),
        transform: ("translateY(" + _vm.prevCardTransformY + "px)")
      })
    }, [_c('card-cover', {
      ref: _vm.getCoverRef(_vm.prevArticleNID),
      refInFor: true,
      staticClass: "cardInvisible",
      class: {
        active: _vm.isActive(_vm.prevArticleNID)
      },
      attrs: {
        "isHideAnimationElement": true,
        "nid": _vm.prevArticleNID,
        "showVideoPlayButton": false
      }
    })], 1) : _vm._e(), (articleNID === _vm.activeNID || _vm.remainPosition(articleNID)) ? [(articleNID === _vm.activeNID && _vm.showTopCover && !_vm.remainPosition(articleNID)) ? [_c('card-cover', {
      ref: _vm.getCoverRef(articleNID),
      refInFor: true,
      class: {
        active: _vm.isActive(articleNID), 'to-top': _vm.atTop && _vm.showTopCover, bounce: _vm.bounce, reset: _vm.cardReset
      },
      style: ({
        'margin-top': _vm.cardMargintop + 'vh'
      }),
      attrs: {
        "cardPosition": "top",
        "showVideoPlayButton": _vm.showVideoPlayButton,
        "actionToggle": _vm.cardActionAnimate,
        "isHideAnimationElement": !(articleNID === _vm.activeNID),
        "nid": articleNID
      },
      on: {
        "cardMounted": _vm.cardMounted
      }
    }, [_c('div', {
      ref: "arrowsHoverWrapper",
      refInFor: true,
      staticClass: "arrowsHover hidden-sm-down row",
      attrs: {
        "slot": "arrowsHover"
      },
      slot: "arrowsHover"
    }, [_c('div', {
      ref: "arrowsHover",
      refInFor: true,
      staticClass: "left-area arrow-block",
      on: {
        "mouseover": function($event) {
          _vm.forceShowArrows('left')
        }
      }
    }), _c('div', {
      staticClass: "center-area arrow-block",
      on: {
        "mouseenter": _vm.forceHideArrows
      }
    }), _c('div', {
      ref: "arrowsHover",
      refInFor: true,
      staticClass: "right-area arrow-block",
      on: {
        "mouseover": function($event) {
          _vm.forceShowArrows('right')
        }
      }
    }), _c('div', {
      staticClass: "card-middle"
    })])])] : _vm._e(), _c('div', {
      ref: _vm.getBodyCardWrapperRef(articleNID),
      refInFor: true,
      staticClass: "article-body-card-wrapper vw-100",
      class: {
        bounce: _vm.bounceBottom, 'with-card-video': _vm.isShowVideo[articleNID], bodyFadeIn: _vm.bodyFadeIn
      },
      style: ({
        height: _vm.bodyMaxHeight
      })
    }, [_c('div', {
      ref: "cardVideoContainer",
      refInFor: true,
      staticClass: "card-video-container"
    }, [_c('card-video', {
      ref: _vm.cardVideoNID,
      refInFor: true,
      staticClass: "no-article-swipe",
      class: {
        show: _vm.isShowVideo[articleNID], hide: !_vm.isShowVideo[articleNID]
      },
      attrs: {
        "nid": _vm.activeNID,
        "autoStart": _vm.videoAutoStart(),
        "showCusPlayButton": true,
        "bindOnAction": _vm.bindVideoAction,
        "parentActionOnHide": _vm.actionOnVideoHide
      }
    })], 1), _c('node-body', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      ref: _vm.getArticleRef(articleNID),
      refInFor: true,
      class: {
        reset: _vm.bottomCardReset, 'bounce-bottom': _vm.bounceBottom
      },
      style: ({
        'margin-top': _vm.bodyMarginTop + 'vh'
      }),
      attrs: {
        "nid": articleNID
      }
    }), (_vm.arrowNext && _vm.nextArticleNID) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      staticClass: "arrow-down-wrapper",
      class: _vm.articleType
    }, [_c('div', {
      ref: "bottomDivider",
      refInFor: true,
      staticClass: "bottom-divider"
    }), _c('svg-icon-arrow-down-one')], 1) : _vm._e(), (_vm.nextArticleNID) ? _c('div', {
      staticClass: "next-article-indication"
    }, [_c('div', {
      staticClass: "hidden-sm-up coming-next"
    }, [_vm._v("and now"), _c('br'), _vm._v("this")]), _c('div', {
      staticClass: "bottom-card-invader hidden-sm-up"
    }, [_c('icon-bottom-card-invader')], 1)]) : _vm._e(), _c('monster-newsletter-form-desktop', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      ref: "monsterNewsletter",
      refInFor: true,
      staticClass: "monster-newsletter-widget hidden-sm-down",
      attrs: {
        "slot": "content",
        "sections": _vm.node.sections,
        "gtmType": "gtmType_newsletter-footer"
      },
      slot: "content"
    }), (_vm.nextArticleNID && _vm.activeNID == articleNID) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showNodeBody),
        expression: "showNodeBody"
      }],
      ref: "articleBottomCardWrapper",
      refInFor: true,
      staticClass: "article-bottom-card-wrapper"
    }, [_c('card-cover', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showBottomCover),
        expression: "showBottomCover"
      }],
      ref: _vm.getCoverRef(_vm.nextArticleNID),
      refInFor: true,
      staticClass: "cardInvisible bottom-card",
      class: {
        active: _vm.isActive(_vm.nextArticleNID), fullHeight: !_vm.bottomBlankSpace, 'smooth-animate': _vm.bottomCardSmoothAnimate
      },
      style: ({
        transform: ("scale(" + _vm.bottomCardScale + ") translate3d(0,0,0) translateZ(0)"),
        'transform-origin': 'top center'
      }),
      attrs: {
        "isHideAnimationElement": true,
        "nid": _vm.nextArticleNID,
        "showAction": false,
        "showVideoPlayButton": false,
        "cardPosition": "bottom"
      }
    }), (_vm.bottomBlankSpace) ? _c('div', {
      ref: "bottomCardBlankSpace",
      refInFor: true,
      staticClass: "bottom-card-cover-blank-space hidden-xs-down"
    }, [_c('div', {
      staticClass: "scroll-to-continue"
    }, [_vm._v("Scroll to continue")]), _c('div', {
      staticClass: "scroll-down-arrow"
    }, [_c('svg-arrow-down', {
      attrs: {
        "width": "100%",
        "height": "100%"
      }
    })], 1)]) : _vm._e(), _c('div', {
      staticClass: "header_text text-center"
    }, [_vm._v(_vm._s(_vm.nextCoverHeaderText))])], 1) : _vm._e(), (key === _vm.articleList.length - 1 && !_vm.nextArticleNID) ? [_c('tech-lift-footer', {
      staticClass: "vw-100",
      attrs: {
        "logo": "",
        "showTopicList": "",
        "theme": "footer-red",
        "iconColor": "rgba(220, 58, 53, 1)",
        "gtm-event-category": "Footer"
      }
    })] : _vm._e()], 2)] : (_vm.lazyCover(key)) ? [_c('card-cover', {
      attrs: {
        "isHideAnimationElement": _vm.showVideoPlayButton,
        "showVideoPlayButton": true,
        "nid": articleNID,
        "cardPosition": "lazy"
      }
    }), _c('div', {
      staticClass: "card-cover-blank-space hidden-xs-down"
    })] : _vm._e()], 2)
  })], 2), (_vm.hasRelatedPersonInBody) ? _c('related-person-overlay-header', {
    staticClass: "related-person-overlay-header",
    class: {
      'hidden-right': !_vm.relatedPersonOverlay.toggle, 'showing-desktop-header': _vm.showDesktopHeaderMenu
    },
    attrs: {
      "theme": _vm.currentViewPort,
      "nid": _vm.relatedPersonOverlay.nid,
      "overlayBody": this.$refs.relatedPersonOverlay,
      "width": "640px"
    }
  }) : _vm._e(), (_vm.hasRelatedPersonInBody && _vm.relatedPersonOverlay.toggle) ? _c('div', {
    staticClass: "related-person-overlay-layer",
    class: [{
      'hidden-right': !_vm.relatedPersonOverlay.toggle
    }, ("theme-" + _vm.currentViewPort)]
  }) : _vm._e(), (_vm.hasRelatedPersonInBody) ? _c('div', {
    staticClass: "related-person-overlay",
    class: [{
      'hidden-right': !_vm.relatedPersonOverlay.toggle,
      'showing-desktop-header': _vm.showDesktopHeaderMenu
    }, ("theme-" + _vm.currentViewPort)]
  }, [_c('related-person-overlay', {
    ref: "relatedPersonOverlay",
    staticClass: "overlay",
    attrs: {
      "overlay": true,
      "showingOverlay": _vm.relatedPersonOverlay.toggle,
      "nid": _vm.relatedPersonOverlay.nid,
      "theme": _vm.currentViewPort
    }
  })], 1) : _vm._e(), (_vm.hasRelatedPersonInBody) ? _c('related-person-overlay-share-bar', {
    class: {
      'hidden-right': !_vm.relatedPersonOverlay.toggle
    },
    attrs: {
      "theme": _vm.currentViewPort,
      "nid": _vm.relatedPersonOverlay.nid,
      "overlayBody": this.$refs.relatedPersonOverlay
    }
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrowPrev && (_vm.arrowInit || _vm.hoverCover)),
      expression: "arrowPrev && (arrowInit || hoverCover)"
    }],
    ref: "articleArrowLeft",
    staticClass: "arrow-prev article-arrow",
    class: {
      arrowFadeIn: _vm.arrowVisible, onCover: _vm.hoverCover
    },
    style: (_vm.newArrowTopPercentage),
    on: {
      "click": function($event) {
        _vm.prevArticle()
      }
    }
  }, [_c('icon-arrow-left', {
    attrs: {
      "width": "70",
      "height": "70"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.arrowNext && (_vm.arrowInit || _vm.hoverCover)),
      expression: "arrowNext && (arrowInit || hoverCover)"
    }],
    ref: "articleArrowRight",
    staticClass: "arrow-next article-arrow",
    class: {
      arrowFadeIn: _vm.arrowVisible, onCover: _vm.hoverCover
    },
    style: (_vm.newArrowTopPercentage),
    on: {
      "click": function($event) {
        _vm.nextArticle()
      }
    }
  }, [_c('icon-arrow-right', {
    attrs: {
      "width": "70",
      "height": "70"
    }
  })], 1), _c('div', {
    staticClass: "fixed-bottom"
  }, [(_vm.allowNewsletterWidgetPopup) ? _c('div', {
    staticClass: "newsletter hidden-sm-up",
    style: ({
      'left': _vm.newsLetterWidgetXPadding + 'px'
    })
  }, [_c('pop-up-wrapper', [_c('monster-newsletter-form', {
    attrs: {
      "slot": "content",
      "sections": _vm.node.sections,
      "gtmType": "gtmType_newsletter-adhesive"
    },
    slot: "content"
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9db8fe76","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/ArticleView.vue
// module id = 1773
// module chunks = 1